/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.blockModule', ['as.sortable', 'mm.foundation', 'ui.utils', 'bulbApp.ajaxModule',
  'bulbApp.authModule', 'bulbApp.avatarImageModule', 'bulbApp.configModule', 'bulbApp.translateModule'])

.constant('TITLE_THRESHOLD_LENGTH', {
  shortenedTitleLength: 45
})
.run(['$rootScope', 'TITLE_THRESHOLD_LENGTH', function($rootScope, TITLE_THRESHOLD_LENGTH) {
  $rootScope.TITLE_THRESHOLD_LENGTH = TITLE_THRESHOLD_LENGTH;
}])

// Default values for jQuery plugins applied by uiJq (jQuery Passthru Directive)
.value('uiJqConfig', {
  dotdotdot: {
    watch: true,
    callback: function(isTruncated, originalContent) {
      // FUTURE: if (isTruncated) { /* Display originalContent[0].textContent as a tooltip */ }
    }
  }
});
